// 2узел собирающий отдельные запросы(эндпоинты) - тут они встроены(бывает вынесены в отдельные файлы)
import { createApi } from "@reduxjs/toolkit/query/react";
import { formatFunction } from "./service/formatFunction";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import { ProfileEducationModalType } from "src/old/Types/ProfileEditType";
import {
	FileUploadResponse,
	FileUploadType,
	RequestResponse,
} from "./types/types";
import { formatToISO } from "src/business.InterfaceLayer/store/services/formatToISO";
import { locality } from "src/old/Utils/FormikConfigs/ProfileEdit";

export const profileEducationApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: "profileEducationApi",
	endpoints: (builder) => ({
		postProfileEducationDocuments: builder.mutation<
			FileUploadResponse,
			{ data: FileList[]; type: FileUploadType; userId?: string | null }
		>({
			query: ({ data, type, userId }) => {
				const formData = new FormData();
				data.forEach((file, i) => {
					formData.append(`files[${i}]`, file[0]);
				});
				formData.append("type", String(type));

				return {
					url: `/lk/upload/files${userId ? `?userId=${userId}` : ""}`,
					method: "POST",
					body: formData,
				};
			},
			transformResponse: (response: FileUploadResponse) => response,
		}),

		postProfileEducation: builder.mutation<
			RequestResponse,
			ProfileEducationModalType
		>({
			query: (data) => {
				const userId = localStorage.getItem("userId") || "";
				if (!userId) {
					throw new Error("User ID is not found in localStorage");
				}

				const payload = {
					isStudent: data.isStudent,
					studentCard: data.studentCard
						? {
								institute: data.studentCard.institute || "",
								number: data.studentCard.number || "",
								city: data.studentCard.city || "",
								issueDate: data.studentCard.issueDate
									? formatToISO(data.studentCard.issueDate)
									: null,
								speciality: data.studentCard.speciality ?? null,
								specialization: data.studentCard.specialization ?? null,
								locality: data.studentCard.locality || "",
						  }
						: null,
					diploma:
						data.diploma && !data.isStudent
							? {
									nameInstitution: data.diploma.nameInstitution || "",
									diplomNumber: data.diploma.diplomNumber || "",
									diplomSerial: data.diploma.diplomSerial || "",
									locality: data.diploma.locality || "",
									issueDate: data.diploma.issueDate
										? formatToISO(data.diploma.issueDate)
										: null,
									academicDegree: data.diploma.academicDegree ?? null,
									surnameByDiplom: data.diploma.surnameByDiplom || "",
									speciality: data.diploma.speciality ?? null,
									specialization: data.diploma.specialization ?? null,
									diplomChecked: data.diploma.diplomChecked ?? false,
							  }
							: null,
				};

				//console.log("payloadEducation:", payload);

				return {
					url: `/v2/user/${userId}/profile/education`,
					method: "PUT",
					body: JSON.stringify(payload),
					headers: {
						"Content-Type": "application/json",
					},
				};
			},
			transformResponse: (response: RequestResponse) => response,
		}),
	}),
});

export const {
	usePostProfileEducationMutation,
	usePostProfileEducationDocumentsMutation,
} = profileEducationApi;
